import { getStorage, setStorage, StorageType } from "./storage"
import { concatWithSymbol } from "./common"
import _concat from "lodash/concat"

export let opKey
export let utmKey
export let adKey
const channelKey = "m_ref"

// 百度通配符
const bdKeys = ["bd_vid"]
// 字节通配符
const byteKeys = ["adid", "creativeid", "creativetype", "clickid"]
// 腾讯广告落地页归因参数
const tencentKeys = ["wx_traceid", "wx_aid", "weixinadkey", "uxinfo", "gdt_vid", "weixinadinfo", "qz_gdt"]

const adParams = _concat(bdKeys, byteKeys, tencentKeys)

export function analyzeSearchParams(uaId) {
    opKey = concatWithSymbol([uaId, "originOpenId"])
    utmKey = concatWithSymbol([uaId, "utm"])
    adKey = concatWithSymbol([uaId, "ad"])
    setChannel()
    const query = window.location.href.split("?")[1]
    if (query) {
        // URLSearchParams 会将裸 + 解析为空格，解析前先保留其真实加号语义。
        const searchParams = new URLSearchParams(query.replace(/\+/g, "%2B"))
        setUtm(searchParams)
        setOriginOpenId(searchParams)
        setADParams(searchParams)
    }
}

export function setChannel() {
    const query = window.location.search.slice(1).replace(/\+/g, "%2B")
    const pageChannel = new URLSearchParams(query).get(channelKey)
    const configuredChannel = window.env?.M_REF
    // m_ref 使用点分隔引用链，按首次出现顺序保留唯一的引用。
    const references = [pageChannel, configuredChannel]
        .filter(Boolean)
        .reduce((references, value) => references.concat(value.split(".")), [])
        .filter(Boolean)
    const channel = [...new Set(references)].join(".")
    if (channel) {
        window.sessionStorage.setItem(channelKey, channel)
    } else {
        // 服务端未匹配到当前微站来源时，不能沿用上一个微站遗留的令牌。
        window.sessionStorage.removeItem(channelKey)
    }
}

export function getChannel() {
    return window.sessionStorage.getItem(channelKey)
}

export function setOriginOpenId(searchParams) {
    let originOpenId = ""
    searchParams.forEach((v, k) => {
        if (v && (k === "c_source" || k === "originOpenId")) {
            originOpenId = decodeURIComponent(v)
        }
    })
    if (originOpenId) {
        setStorage(opKey, originOpenId, false, StorageType.session)
    }
}

export function getOriginOpenId() {
    return getStorage(opKey, StorageType.session)
}

export function setUtm(searchParams) {
    const res = {}
    searchParams.forEach((v, k) => {
        if (v && /^utm_|^source$|^source_id$/.test(k)) {
            res[k] = v
        }
    })
    if (Object.keys(res).length) {
        setStorage(utmKey, res, false, StorageType.session)
    }
}

export function setADParams(searchParams) {
    const res = {}
    searchParams.forEach((v, k) => {
        if (v && adParams.indexOf(k) > -1) {
            res[k] = v
        }
    })
    if (Object.keys(res).length) {
        setStorage(adKey, res, false, StorageType.session)
    }
}
export function getADParams() {
    return getStorage(adKey, StorageType.session)
}

export function getUtm() {
    return getStorage(utmKey, StorageType.session)
}

// setTimeout(analyzeSearchParams, 0);
